import { render, staticRenderFns } from "./reroute-suggestion.vue?vue&type=template&id=0a1671d4&scoped=true"
import script from "./reroute-suggestion.ts?vue&type=script&lang=ts&external"
export * from "./reroute-suggestion.ts?vue&type=script&lang=ts&external"
import style0 from "./reroute-suggestion.scss?vue&type=style&index=0&id=0a1671d4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1671d4",
  null
  
)

export default component.exports